import get from 'lodash/get'
import set from 'lodash/set'
import { useCallback, useContext } from 'react'

import { ECommerceProductActionEvent } from '@Events/ECommerce'
import { handleEvent } from '@Events/Manager'
import { OtherEvent } from '@Events/Other'
import { BlockContext } from '@Globals/CMS/Context'

interface UseMParticleProps {
  sourceID?: string
}

export const useMParticle = ({ sourceID }: UseMParticleProps = {}) => {
  const { id: blockID } = useContext(BlockContext)
  const source = sourceID || blockID

  const logProductAction = useCallback(
    (
      params: ConstructorParameters<typeof ECommerceProductActionEvent>[0],
    ) => {
      if (!params.products || params.products.length === 0) {
        throw new Error('missing products')
      }

      const categoryIDs = params.products[0]?.Attributes?.category_ids || ''

      if (get(params, 'custom_attributes.source_id') === 'inherit') {
        set(params, 'custom_attributes.source_id', source)
      }

      if (get(params, 'custom_attributes.category_ids') === 'inherit') {
        set(params, 'custom_attributes.category_ids', categoryIDs)
      }

      handleEvent(new ECommerceProductActionEvent(params))
    },
    [source],
  )

  const otherEvent = useCallback((params: ConstructorParameters<typeof OtherEvent>[0]) => {
    if (get(params, 'attributes.source_id') === 'inherit') {
      set(params, 'attributes.source_id', source)
    }

    handleEvent(new OtherEvent(params))
  }, [source])

  return {
    logProductAction,
    otherEvent,
  }
}
